import HorizontalScrollButtons from './HorizontalScrollButtons';
import { IHorizontalScrollButtons } from './HoriztonalScrollButtons.interface';

export default HorizontalScrollButtons;
export { HorizontalScrollButtons, IHorizontalScrollButtons };
